import React from 'react';
import { RendererCssClassName } from '../../consts';
import { useSelectAllTrap } from '../utils/use-select-all-trap';
export default function Doc(props) {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  return /*#__PURE__*/React.createElement("div", {
    className: RendererCssClassName.DOCUMENT
  }, props.children);
}
export function DocWithSelectAllTrap(props) {
  return /*#__PURE__*/React.createElement("div", {
    ref: useSelectAllTrap()
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: RendererCssClassName.DOCUMENT
  }, props.children);
}